import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  title: string;
  id?: string;
  /** セクション番号。渡すと背景にウォーターマーク表示される */
  number?: number;
  /** サブ番号（例: "3.1"）。渡すと緑基調の小さめ見出し帯になる */
  subNumber?: string;
  children: React.ReactNode;
};

/**
 * 記事内セクション区切り
 * シェブロン（矢印）形の見出し帯。右端に向かって透過するグラデーション。
 * number を渡すと背景に大きく番号が表示される。
 */
const WorkflowSection: React.FC<Props> = ({ title, id, number, subNumber, children }) => {
  const isSub = subNumber != null;

  return (
    <Box id={id}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          height: isSub ? 30 : 36,
          mb: 2,
          overflow: 'hidden',
          background: isSub
            ? 'linear-gradient(to right, #1b5e20, #1b5e2000)'
            : 'linear-gradient(to right, #1a3a5c, #1a3a5c00)',
          clipPath: 'polygon(0 0, calc(100% - 16px) 0, 100% 50%, calc(100% - 16px) 100%, 0 100%)',
          pl: isSub ? 4.5 : 5,
          pr: 4,
          borderRadius: '4px 0 0 4px',
        }}
      >
        {/* 背景に溶け込む番号 */}
        {(number != null || isSub) && (
          <Typography
            sx={{
              position: 'absolute',
              left: 4,
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: isSub ? 22 : 48,
              fontWeight: 900,
              lineHeight: 1,
              color: isSub ? 'rgba(255, 255, 255, 0.22)' : 'rgba(255, 255, 255, 0.15)',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          >
            {isSub ? subNumber : number}
          </Typography>
        )}
        {/* タイトルテキスト */}
        <Typography
          variant={isSub ? 'body2' : 'subtitle2'}
          fontWeight={isSub ? 600 : 700}
          sx={{ color: '#fff', letterSpacing: 0.3, whiteSpace: 'nowrap', position: 'relative' }}
        >
          {title}
        </Typography>
      </Box>
      <Stack spacing={1.5}>{children}</Stack>
    </Box>
  );
};

export default WorkflowSection;
